// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"DeviceBrandScreen_buttonsContainer__lPj2D","button":"DeviceBrandScreen_button__dKG9o"};